import { render, staticRenderFns } from "./v3.vue?vue&type=template&id=436248fd&scoped=true&"
import script from "./v3.vue?vue&type=script&lang=js&"
export * from "./v3.vue?vue&type=script&lang=js&"
import style0 from "./v3.vue?vue&type=style&index=0&id=436248fd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436248fd",
  null
  
)

export default component.exports